import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsService } from '../../core/settings/settings.service';
import { ThemesService } from '../../core/themes/themes.service';
import { TranslatorService } from '../../core/translator/translator.service';
import { AuthService } from "../../shared/authentication/auth.service";

declare var $: any;


@Component({
  selector: 'app-offsidebar',
  templateUrl: './offsidebar.component.html',
  styleUrls: ['./offsidebar.component.scss']
})
export class OffsidebarComponent implements OnInit, OnDestroy  {

    currentTheme: any ;
    selectedLanguage: string;
    clickEvent = 'click.offsidebar';
    $doc: any = null;

    constructor(public settings: SettingsService,
                    public themes: ThemesService,
                    public translator: TranslatorService,
                    private router: Router,
                    private authService: AuthService,) {
        this.currentTheme = themes.getDefaultTheme();
        this.settings.layout.offsidebarOpen = false;
        this.selectedLanguage = translator.getCurrentLanguage();
    }

    ngOnInit() {
        this.anyClickClose();
    }

    setTheme() {
        this.themes.setTheme(this.currentTheme);
    }

    getLangs() {
        return this.translator.getAvailableLanguages();
    }

    setLang(value) {
        this.translator.useLanguage(value);
    }

    anyClickClose() {
        this.$doc = $(document).on(this.clickEvent, (e) => {
            let $target = $(e.target);
            if (this.settings.layout.offsidebarOpen &&
                    !$target.hasClass('offsidebar') &&
                    !$target.parents('.offsidebar').length && 
                    !$target.parents('.offsidebar-icon').length) {
                this.settings.layout.offsidebarOpen = false;
            }
        });
    }

    ngOnDestroy() {
        if (this.$doc) {
            this.$doc.off(this.clickEvent);
        }
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// ./src/app/layout/offsidebar/offsidebar.component.ts